import BaseObject from '../../../../base/base_object';
import {DEVICE_DETECTION} from './device_detection_hybrid_consts';
import _ from "../../../../utils/underscore";
import {KEY_NAME} from "../../native/native_const";
import {SYSTEM_EVENTS} from "../../../../events/events";
import {DialogButtonClickHandleResultEnum} from "../../../../../../app-react/services/dialog/dialog.service.interface";


/**
 *
 *
 */
class DeviceDetection extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'DeviceDetection';

    _HybridService = null;


    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        this._HybridService.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
            if(this._HybridService.serviceFactory.regulationService().getRegulation().isDeviceDetectionEnabled()) {
                this._HybridService.getDeviceDetectionInfo().then(data => {
                    this._checkIfNeedPopUp(data);
                });
            }
        });

        return this;
    }

    _checkIfNeedPopUp(data) {

        try {

            const json           = _.safeJSONandDecode(data);
            const datainfo       = json[KEY_NAME.DATA];
            const bIsEmulator    = this._getVal(datainfo, DEVICE_DETECTION.KEY_IS_EMULATOR);
            const bIsRootMethod1 = this._getVal(datainfo, DEVICE_DETECTION.KEY_IS_ROOT_1);
            const bIsRootMethod2 = this._getVal(datainfo, DEVICE_DETECTION.KEY_IS_ROOT_2);
            const bIsRootMethod3 = this._getVal(datainfo, DEVICE_DETECTION.KEY_IS_ROOT_3);
            const bIsJailBroken  = this._getVal(datainfo, DEVICE_DETECTION.KEY_IS_JAIL_BROKEN);

            let showPopUp = false;
            let title = '';
            let text = '';
            let btntxt = this._HybridService.serviceFactory.languageService().translation('close_app');

            if(bIsEmulator){
                showPopUp = true;
                title = this._HybridService.serviceFactory.languageService().translation('emulator_detected_title');
                text = this._HybridService.serviceFactory.languageService().translation('emulator_detected_txt');
            }else if( bIsRootMethod1 || bIsRootMethod2 || bIsRootMethod3){
                showPopUp = true;
                title = this._HybridService.serviceFactory.languageService().translation('rooted_detected_title');
                text = this._HybridService.serviceFactory.languageService().translation('rooted_detected_txt');
            }else if(bIsJailBroken){
                showPopUp = true;
                title = this._HybridService.serviceFactory.languageService().translation('jail_broken_title');
                text = this._HybridService.serviceFactory.languageService().translation('jail_broken_txt');
            }


            if(showPopUp){
                this._showPopUp(title, text, btntxt);
            }
        }
        catch (e) {
            this._HybridService.logger.error('DeviceDetection: ' + e);
        }
    }

    _showPopUp(title, text, btntxt){

        this._HybridService.serviceFactory.dialogProxyService().showSimpleTextModal({
            title: title,
            text: text,
            hideCloseButton: true,
            buttons: [
                {
                    buttonPreset: 'primary',
                    text: btntxt,
                    onClick: async () => {
                        this._HybridService.closeApp();
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                    }
                }
            ]
        });
    }

    _getVal(datainfo, key){
        return 'true' === datainfo[key];
    }
}

export default DeviceDetection;
